// import Auth from "./auth";
import axios from "axios";
import dayjs from "dayjs";
import { hasLiveSensor } from "@/helpers/sensorTypes";
// import { isRuleActiveNow } from "@/utils/deviceAlertStatus";

let VIEW = {};

class Devices {
  constructor() {
    this.setViewObj();
  }

  setViewObj() {
    VIEW = Object.keys(VIEW).length > 0 ? VIEW : {};
    if (!VIEW && localStorage.getItem("mydataview")) {
      VIEW = JSON.parse(
        decodeURIComponent(
          Array.prototype.map
            .call(
              window.atob(localStorage.getItem("mydataview")),
              (c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
            )
            .join("")
        )
      );
    }
  }

  pull() {
    axios
      .get(`/api/switch/`)
      .then((res) => {
        if (res.data) {
          this.store(res.data);
        }
        return res.data;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  store(items) {
    let view = {};
    for (let device in items) {
      if (device in items) {
        if (items[device] && items[device].view) {
          view[device] = items[device].view;
        }
      }
    }
    VIEW = view;
    const base64view = btoa(
      encodeURIComponent(JSON.stringify(view)).replace(
        /%([0-9A-F]{2})/g,
        (match, p1) => String.fromCharCode(parseInt(p1, 16))
      )
    );
    localStorage.setItem("mydataview", base64view);
    items = btoa(
      encodeURIComponent(JSON.stringify(items)).replace(
        /%([0-9A-F]{2})/g,
        (match, p1) => String.fromCharCode(parseInt(p1, 16))
      )
    );
    localStorage.setItem("mydata", items);
  }

  get(item = false) {
    let items = localStorage.getItem("mydata");
    if (items) {
      items = JSON.parse(
        decodeURIComponent(
          Array.prototype.map
            .call(
              window.atob(items),
              (c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
            )
            .join("")
        )
      );
      if (item) {
        return items[item];
      }
      return items;
    } else {
      return null;
    }
  }

  unstore() {
    localStorage.removeItem("mydata");
  }

  analyze(items) {
    for (let item in items) {
      items[item] = this.analyzeItem(items[item]);
    }
    return items;
  }

  analyzeItem(device) {
    // Normalize slug: if the API returns a full URL as the slug, extract just the last segment
    if (device.slug && /^https?:\/\//.test(device.slug)) {
      const parts = device.slug.replace(/\/$/, "").split("/");
      device.slug = parts[parts.length - 1] || device.slug;
    }
    // console.log(device);
    // try {
    const hasData = device.data && Object.keys(device.data) != 0;
    // if (device.data && Object.keys(device.data) != 0) {
    // }
    if (!hasData) device.data = {};
    this.fixName(device);
    if (!device.view) {
      const OLD = this.get(device.slug);
      if (OLD && OLD.view) device.view = OLD.view;
    }
    this.checkConnection(device);
    if (hasData && device.role == 1 && !isNaN(device.data.output)) {
      device.status = device.data.output ? "On" : "Off";
    } else {
      this.exceeds(device);
    }
    if (device.active_status == 0) {
      device.status = "Unpaid";
    }
    if (!device.connection) device.status = "Offline";
    this.getDevmodes(device);
    this.classifyDevice(device);
    const lastReceived = device.received_at ?? device.data.received;
    device.received = dayjs(lastReceived).format("HH:mm:ss DD/MM/YYYY");
    return device;
    // } catch (error) {
    //   console.error(error);
    //   console.log(device);
    // }
  }

  fixName(device) {
    const NAME = device.name;
    if (!NAME) {
      const OLD = this.get(device.slug);
      device.name = OLD && OLD.name ? OLD.name : NAME;
      if (name && NAME) device.name = NAME;
      if (device.name) {
        localStorage.setItem(device.slug + "-name", device.name);
      } else {
        let OLDNAME = localStorage.getItem(device.slug + "-name");
        if (OLDNAME) device.name = OLDNAME;
      }
    }
  }

  checkConnection(device) {
    // device.connection = device.online;
    const receivedAt = device.received_at ?? device.data.received;
    const received = +new Date(receivedAt);
    const ttl = device.offline_notification.ttl * 60;
    const diff = Math.floor((+new Date() - received) / 1000);
    const isOnline = diff <= ttl;
    device.connection = isOnline;
  }

  exceeds(device) {
    let exceeds = null;
    let rules = device.rules;
    let status = "On";
    let exceedsVal = null;
    let exceedsRule = null;
    const exceedsRules = [];

    const binarySensors = [
      "hall",
      "drycontact",
      "isVibrating",
      "detection",
      "motion",
      "load_state",
      "alarm_state",
      "power_state",
    ];

    const normalizeBinaryValue = (value) => {
      if (value === true || value === "true") return 1;
      if (value === false || value === "false") return 0;
      const parsed = Number.parseInt(value, 10);
      return Number.isNaN(parsed) ? NaN : parsed;
    };

    for (let i = 0; i < rules.length; i++) {
      const sensors = device.data.sensors ?? {};
      const sensorName = rules[i].sensor;
      const isBinarySensor = binarySensors.includes(sensorName);

      const ruleValue = isBinarySensor
        ? normalizeBinaryValue(rules[i].value)
        : Number.parseFloat(rules[i].value);
      const secondRuleValue = Number.parseFloat(rules[i].second_value);

      if ("temperatures" in sensors) {
        sensors["temperature"] = sensors["temperatures"][0];
      }
      const sensorValue = isBinarySensor
        ? normalizeBinaryValue(sensors[sensorName])
        : Number.parseFloat(sensors[sensorName]);

      if (!(sensorName in sensors)) continue;
      if (Number.isNaN(ruleValue) || Number.isNaN(sensorValue)) continue;

      if (rules[i].sensor in sensors) {
        if (ruleValue > sensorValue && rules[i].action == "<") {
          exceeds = true;
          status = "Off";
          exceedsVal = rules[i].value;
          exceedsRule = rules[i].sensor;
          exceedsRules.push({
            id: rules[i].id,
            sensor: rules[i].sensor,
            action: rules[i].action,
            value: rules[i].value,
            second_value: rules[i].second_value,
            sensor_value: sensors[sensorName],
          });
        }
        if (ruleValue < sensorValue && rules[i].action == ">") {
          exceeds = true;
          exceedsVal = ruleValue;
          status = "Off";
          exceedsRule = rules[i].sensor;
          exceedsRules.push({
            id: rules[i].id,
            sensor: rules[i].sensor,
            action: rules[i].action,
            value: rules[i].value,
            second_value: rules[i].second_value,
            sensor_value: sensors[sensorName],
          });
        }
        if (
          !Number.isNaN(secondRuleValue) &&
          ruleValue <= sensorValue &&
          secondRuleValue >= sensorValue &&
          rules[i].action == "><"
        ) {
          exceeds = true;
          exceedsVal = ruleValue;
          status = "Off";
          exceedsRule = rules[i].sensor;
          exceedsRules.push({
            id: rules[i].id,
            sensor: rules[i].sensor,
            action: rules[i].action,
            value: rules[i].value,
            second_value: rules[i].second_value,
            sensor_value: sensors[sensorName],
          });
        }

        device.exceeds = exceeds;
        device.status = status;
        device.exceedsVal = exceedsVal;
        device.exceedsRule = exceedsRule;
        device.exceedsRules = exceedsRules;
      }
    }
    if (!Array.isArray(device.exceedsRules)) device.exceedsRules = exceedsRules;
    device.status = status;
  }

  getDevmodes(device) {
    let devmodes = 0;
    switch (device.settings.sensor_type) {
      case 1:
        devmodes = 3;
        break;
      case 2:
      case 3:
      case 4:
      case 5:
        devmodes = 5;
        break;
      case device.data.battery &&
        device.data.battery.value !== null &&
        device.data.sensor_type > 0 &&
        device.data.sensor_type < 7:
        devmodes = 7;
        break;
    }
    device.devmodes = devmodes;
  }

  classifyDevice(device) {
    // Check all three conditions for sensor classification
    const hasIdentifier = device.identifier && device.identifier.trim() !== "";
    const hasSignalGatewayMac =
      device.data &&
      device.data.signal &&
      Object.keys(device.data.signal).length > 0;
    const hasGPS =
      device.data &&
      device.data.sensors &&
      device.data.sensors.gps &&
      (device.data.sensors.gps.latitude !== undefined ||
        device.data.sensors.gps.longitude !== undefined);
    // Do not mutate backend-provided sensor types here. The current device
    // state comes from HTTP/websocket payloads; helpers can derive behavior
    // from sensor_type_info and live sensors without rewriting persisted data.
    device.has_vibration_energy = hasLiveSensor(device, "vibration_energy");
    // All three conditions must be true for sensor classification
    device.deviceType = "sensor";
    if (hasIdentifier && hasSignalGatewayMac && hasGPS) {
      device.deviceType = "gateway";
    }

    return device;
  }
}

export default new Devices();
